<template>
  <div class="GatewayResourceSearch">
    <div class="GatewayResource-title">
      <div>{{ $t("DocDBMonitor.redshift") }}</div>
      <div>
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:aws:DocDBManage:update'
          ]"
          :loading="loading"
          @click="update"
          >{{ $t("RAM.common.update") }}</Button
        >
        <Button
          type="primary"
          :loading="modal_loading"
          @click="exportList"
          v-hasPermission="[
            'resourceConfigurationManagement:aws:DocDBManage:export'
          ]"
          >{{ $t("common.export") }}</Button
        >
      </div>
    </div>
    <Row :gutter="4">
      <!-- 选择公司 -->
      <div v-if="company == 1">
        <Col span="6">
          <Select
            v-model="searchData.companyId"
            filterable
            :placeholder="$t('RAM.common.PleaseSelectCompany')"
            :transfer="true"
          >
            <Option value=" " selected>{{ $t("alarms.common.all") }}</Option>
            <Option
              :value="item.id"
              v-for="item in companyList"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </Col>
      </div>
      <Col span="6">
        <Input
          v-model="searchData.accountName"
          :placeholder="$t('RAM.common.filterByAccountName')"
        />
      </Col>
      <Col span="6">
        <Input
          v-model="searchData.dbClusterIdentifier"
          :placeholder="$t('DocDBMonitor.ClusterIdentifier')"
        />
      </Col>
      <Col span="4">
        <Button
          v-hasPermission="[
            'resourceConfigurationManagement:aws:DocDBManage:page'
          ]"
          @click="getData"
          >{{ $t("message.select") }}</Button
        >
      </Col>
    </Row>
    <div style="margin-top:10px"></div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableData"
      style="width: 100.1%;"
    ></Table>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <div style="margin-top:10px"></div>
    <Page
      :current="searchData.pageNum"
      :total="total"
      show-sizer
      :page-size="searchData.pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>

<script>
import { setCookie, getCookie } from "@/utils/cookieUtil.js";
import TableExpandSet from "./TableExpandSet.vue";
export default {
  components: {
    TableExpandSet
  },
  data() {
    return {
      loading: false,
      modal_loading: false,
      company: getCookie(global.companyId),
      total: 0,
      searchData: {
        companyId: "",
        accountName: "",
        dbClusterIdentifier: "",
        pageNum: 1,
        pageSize: 10
      },
      companyList: [],
      tableData: [
        // { name: 1, id: 1, cont: 1, list: [{ name: 2, id: 2, cont: 2 }] }
      ],
      columns: [
        {
          type: "expand",
          width: 30,
          render: (h, params) => {
            // return h("Table", {
            //   props: {
            //     columns: [
            //       { title: "排行榜", align: "center", key: "component" },
            //       { title: "积分", align: "center", key: "version_name" }
            //     ], //表头
            //     data: [] //内部表格展示的数据
            //   }
            // }); //我这里使用的是表格，也可以根据自己的实际情况更换别的组件
            return h(TableExpandSet, {
              props: {
                row: params.row.awsDocDbInstanceDTOS,
                accountIdString: params.row.accountIdString,
                accountName: params.row.accountName
              }
            });
          }
        },
        {
          title: this.$t("RAM.AWS.Gateway.accountName"),
          key: "accountName",
          minWidth: 120
        },
        {
          title: this.$t("RAM.AWS.Gateway.accountID"),
          key: "accountIdString",
          minWidth: 120
        },
        {
          title: this.$t("DocDBMonitor.ClusterIdentifier"),
          key: "dbClusterIdentifier",
          minWidth: 150
        },
        {
          title: this.$t("DocDBMonitor.role"),
          key: "roleName",
          minWidth: 80
        },
        {
          title: this.$t("DocDBMonitor.EngineVersion"),
          key: "engineVersion",
          minWidth: 150
        },
        {
          title: this.$t("DocDBMonitor.AreasAndZones"),
          key: "region",
          minWidth: 160
        },
        {
          title: this.$t("DocDBMonitor.status"),
          key: "status",
          minWidth: 80
        },
        {
          title: this.$t("DocDBMonitor.size"),
          key: "dbClusterMembers",
          minWidth: 80
        }
      ]
    };
  },
  methods: {
    changePage(pageNum) {
      this.searchData.pageNum = pageNum;
      this.getData();
    },
    changeSize(pageSize) {
      this.searchData.pageSize = pageSize;
      this.getData();
    },
    // 获取公司下拉框
    getCompanyDropDownBox: function() {
      this.$api.company
        .getCompanyDropDownBox("userName", getCookie(global.cookieName))
        .then(res => {
          this.companyList = res.data;
        });
    },
    update: function() {
      this.loading = true;
      this.$api.DocDB.updateResource({
        companyId: this.searchData.companyId,
        resourceManagement: 29
      }).then(res => {
        this.loading = false;
        setTimeout(() => {
          this.$Message.success(this.$t("common.updateSuccess"));
        }, 1000);
        this.getData();
      });
    },
    //导出
    exportList: function() {
      if (!this.searchData.companyId) {
        this.$Message.error(this.$t("alarms.common.pleaseSelectCompany"));
        return;
      }
      this.modal_loading = true;
      this.$Message.loading({
        duration: 0,
        content: this.$t("common.exporting")
      });
      // 下载Excel 文件
      this.$api.DocDB.exportAwsDocDbCluster({
        accountName: this.searchData.accountName,
        companyId: this.searchData.companyId,
        dbClusterIdentifier: this.searchData.dbClusterIdentifier
      }).then(res => {
        let fileName = "AWS Document DB List.xls";
        let blob = new Blob([res.data], { type: "application/x-xls" });
        if (window.navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(blob, fileName);
        } else {
          var link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = fileName;
          link.click();
          window.URL.revokeObjectURL(link.href);
        }
        this.modal_loading = false;
        this.$Message.destroy();
        this.$Message.success(this.$t("common.exportSuccess"));
      });
    },
    getData() {
      this.$api.DocDB.pagingQueryAwsDocDbCluster(this.searchData).then(res => {
        this.tableData = res.data.records;
        this.total = res.data.total;
      });
    }
  },
  mounted() {
    this.getCompanyDropDownBox();
  }
};
</script>

<style scoped>
.GatewayResourceSearch {
  padding: 4px 0px 15px 0px;
}
.GatewayResource-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 0px 4px;
  overflow: hidden;
  font-weight: 600;
}
.GatewayResource-title > div:nth-child(1) {
  float: left;
}
.GatewayResource-title > div:nth-child(2) {
  float: right;
  margin-top: -6px;
}
.GatewayResource-top {
  width: 100%;
}
.GatewayResourceSearch >>> td.ivu-table-expanded-cell {
  padding: 0;
  border-bottom: none;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/DocDBMonitor/DocDBManage.vue